module.exports = __webpack_public_path__ + "static/media/390x310-Caracas.c84d2c71.jpg";